// extracted by mini-css-extract-plugin
module.exports = {"nav":"_3YWp-Ww","navList":"_15C6FbD","navItem":"_bpWR1Al","navItemActive":"_36kpnMQ","arrowButton":"_3AP5UbA","collapsed":"_tZrVxuN"};